"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PageTransition = exports.PageTransitionGroup = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj["default"] = obj;
    return newObj;
  }
}

var createAnimationStyles = function createAnimationStyles(_ref) {
  var keyframes = _ref.keyframes,
      delay = _ref.delay,
      duration = _ref.duration,
      timing = _ref.timing,
      fill = _ref.fill,
      origin = _ref.origin,
      onTop = _ref.onTop;
  return (0, _styledComponents.css)(["animation-name:", ";animation-delay:", ";animation-duration:", "ms;animation-timing-function:", ";animation-fill-mode:", ";transform-origin:", ";", ""], keyframes, delay, duration, timing, fill, origin || '50% 50%', onTop && (0, _styledComponents.css)(["z-index:1;"]));
};

var stateMap = {
  entering: function entering(_ref2) {
    var enterAnimation = _ref2.enterAnimation;
    return (0, _styledComponents.css)(["", ";"], createAnimationStyles(enterAnimation));
  },
  exiting: function exiting(_ref3) {
    var exitAnimation = _ref3.exitAnimation;
    return (0, _styledComponents.css)(["", ";"], createAnimationStyles(exitAnimation));
  }
};

var PageTransitionGroup = _styledComponents["default"].div.withConfig({
  displayName: "styles__PageTransitionGroup",
  componentId: "wol1oh-0"
})(["position:relative;width:100%;height:100%;perspective:1200px;overflow:hidden;"]);

exports.PageTransitionGroup = PageTransitionGroup;

var PageTransition = _styledComponents["default"].div.withConfig({
  displayName: "styles__PageTransition",
  componentId: "wol1oh-1"
})(["backface-visibility:hidden;height:100%;left:0;overflow:hidden;position:absolute;top:0;transform-style:preserve-3d;transform:translate3d(0,0,0);width:100%;", ";"], function (_ref4) {
  var state = _ref4.state;
  return stateMap[state];
});

exports.PageTransition = PageTransition;